export function getImages(images) {
  if (!images) return images
  return images.filter(
    image =>
      (!image.slot_key || image.type_key === 'misc') &&
      !image.mime_type?.startsWith('video/')
  )
}
